import React from "react";
import { motion, useReducedMotion } from "framer-motion";
const ease = [0.22, 1, 0.36, 1] as const;
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  distance?: number;
  scale?: number;
};
export function Reveal({
  children,
  className = "",
  delay = 0,
  distance = 15,
  scale
}: RevealProps) {
  const reducedMotion = useReducedMotion();
  const initial = reducedMotion ? {
    opacity: 0
  } : {
    opacity: 0,
    y: distance,
    ...(scale ? {
      scale
    } : {})
  };
  const visible = reducedMotion ? {
    opacity: 1
  } : {
    opacity: 1,
    y: 0,
    scale: 1
  };
  return <motion.div className={className} initial={initial} whileInView={visible} viewport={{
    once: true,
    amount: 0.16
  }} transition={{
    duration: reducedMotion ? 0.2 : 0.55,
    delay,
    ease
  }} data-id="element-19" data-mp="1620umcdc6w57">
      {children}
    </motion.div>;
}
type StaggerGroupProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  stagger?: number;
};
export function StaggerGroup({
  children,
  className = "",
  delay = 0,
  stagger = 0.07
}: StaggerGroupProps) {
  const reducedMotion = useReducedMotion();
  return <motion.div className={className} initial="hidden" whileInView="visible" viewport={{
    once: true,
    amount: 0.12
  }} variants={{
    hidden: {},
    visible: {
      transition: {
        delayChildren: delay,
        staggerChildren: reducedMotion ? 0 : stagger
      }
    }
  }} data-id="element-20" data-mp="1ompqofnkzzgq">
      {children}
    </motion.div>;
}
type StaggerItemProps = {
  children: React.ReactNode;
  className?: string;
  distance?: number;
  scale?: number;
};
export function StaggerItem({
  children,
  className = "",
  distance = 15,
  scale
}: StaggerItemProps) {
  const reducedMotion = useReducedMotion();
  return <motion.div className={className} variants={{
    hidden: reducedMotion ? {
      opacity: 0
    } : {
      opacity: 0,
      y: distance,
      ...(scale ? {
        scale
      } : {})
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: reducedMotion ? 0.2 : 0.52,
        ease
      }
    }
  }} data-id="element-21" data-mp="2ha3iy0gc46ui">
      {children}
    </motion.div>;
}
export const motionEase = ease;